import * as React from "react";
import {
  ClubsState, //,
  ClubSearchActionType,
  ClubSearchAction,
} from "../../types/clubs/clubTypes";

import clubsReducer from "../../reducers/club/clubsReducer";

import { ProcessingStatusType } from "../../types/nlsTypes";
import { getClubs } from "@nls-2022/nls-api";

const initialClubSearchState: ClubsState = {
  clubs: [],
  clubStatus: ProcessingStatusType.pending,
};

export const useClubs = (): [ClubsState, React.Dispatch<ClubSearchAction>] => {
  const [state, dispatch] = React.useReducer(
    clubsReducer,
    initialClubSearchState
  );

  React.useEffect(() => {
    async function fetchClubs() {
      try {
        const response = await getClubs();
        if (response.status === 200) {
          dispatch({
            type: ClubSearchActionType.ClubSearchFetchSuccess,
            payload: response.data,
          });
        } else if (response.status === 404) {
          dispatch({
            type: ClubSearchActionType.ClubSearchFetchNotFound,
          });
        } else {
          dispatch({
            type: ClubSearchActionType.ClubSearchFetchFailure,
          });
        }
      } catch (error) {}
    }
    fetchClubs();
  }, []);

  return [state, dispatch];
};
